import { Battery, Leaf, DollarSign, Home, Building2, Factory, Wheat } from 'lucide-react';
import { Footer } from '../components/Footer';
import { HomeHeader } from '../components/HomeHeader';

export function WhySolar() {
  return (
    <div className="min-h-screen bg-white">
      <HomeHeader />
      
      <main>
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-blue-600 to-blue-700 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Why Choose Solar Solutions?
              </h1>
              <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                Discover how solar energy can transform your power consumption, reduce costs, 
                and contribute to a sustainable future.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 shadow-lg">
                <div className="bg-green-100 w-12 h-12 rounded-full flex items-center justify-center mb-6">
                  <DollarSign className="h-6 w-6 text-green-600" />
                </div>
                <h3 className="text-xl font-bold mb-4">Cost Savings</h3>
                <p className="text-gray-600">
                  Reduce your electricity bills significantly with solar power. 
                  Enjoy ROI within 5-8 years and 25+ years of savings.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg">
                <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-6">
                  <Leaf className="h-6 w-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-4">Environmental Impact</h3>
                <p className="text-gray-600">
                  Reduce your carbon footprint and contribute to a cleaner, 
                  more sustainable environment for future generations.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg">
                <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mb-6">
                  <Battery className="h-6 w-6 text-purple-600" />
                </div>
                <h3 className="text-xl font-bold mb-4">Energy Independence</h3>
                <p className="text-gray-600">
                  Take control of your energy production and reduce dependence 
                  on traditional power sources and rising utility costs.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Solutions for Different Sectors */}
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center mb-12">Solutions for Every Sector</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Home className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold mb-2">Residential</h3>
                <p className="text-gray-600">
                  Perfect for homeowners looking to reduce bills and increase property value.
                </p>
              </div>

              <div className="text-center">
                <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Building2 className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-lg font-semibold mb-2">Commercial</h3>
                <p className="text-gray-600">
                  Ideal for businesses seeking to lower operational costs.
                </p>
              </div>

              <div className="text-center">
                <div className="bg-purple-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Factory className="h-8 w-8 text-purple-600" />
                </div>
                <h3 className="text-lg font-semibold mb-2">Industrial</h3>
                <p className="text-gray-600">
                  Large-scale solutions for manufacturing and processing facilities.
                </p>
              </div>

              <div className="text-center">
                <div className="bg-amber-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Wheat className="h-8 w-8 text-amber-600" />
                </div>
                <h3 className="text-lg font-semibold mb-2">Agricultural</h3>
                <p className="text-gray-600">
                  Sustainable power solutions for farms and agricultural operations.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-blue-600 text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-6">
              Ready to Start Your Solar Journey?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
              Join thousands of satisfied customers who have made the switch to solar energy.
            </p>
            <button className="bg-white text-blue-600 py-3 px-8 rounded-lg hover:bg-blue-50 font-medium">
              Get Your Free Quote
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}